import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const GratitudeBoard = styled.div`
  margin: 0 auto;
  max-width: 80%;
`;

const GratitudeBoardInfo = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-gap-4);
  margin-bottom: var(--size-16);
`;

const GratitudeBoardCards = styled.div`
  column-gap: var(--size-16);
  columns: 240px 6;
  margin: 0 auto;

  @media (max-width: 1280px) {
    columns: 280px 5;
  }

  @media (max-width: 960px) {
    columns: 280px 4;
  }

  @media (max-width: 640px) {
    columns: 280px 1;
  }
`;

const GratitudeBoardCard = styled.div`
  background: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  break-inside: avoid;
  cursor: pointer;
  display: inline-block;
  margin-bottom: var(--size-16);
  padding: var(--size-16);
  width: 100%;

  &:hover {
    box-shadow: var(--shadow-sm);
  }

  ${({ hasImagePadding }) =>
    hasImagePadding &&
    css`
      ${Image.S.Image} {
        padding: var(--size-8);
      }
    `}

  ${Image.S.Image} {
    border: 1px solid var(--color-border-default);
    border-radius: var(--size-border-radius-md);
    display: block;
    height: 140px;
    margin: 0 auto;
    object-fit: contain;
    width: 128px;
  }
`;

const GratitudeBoardCardMessage = styled.div`
  ${Typography.S.Typography} {
    overflow: hidden;
  }
`;

const GratitudeBoardCardInfo = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: var(--size-12) 0;
`;

const GratitudeBoardCardUser = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-8);
`;

const GratitudeBoardEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 250px);
  justify-content: center;

  ${Button.S.Button} {
    margin-top: var(--size-16);
  }
`;

export {
  GratitudeBoard,
  GratitudeBoardCard,
  GratitudeBoardCardInfo,
  GratitudeBoardCardMessage,
  GratitudeBoardCardUser,
  GratitudeBoardCards,
  GratitudeBoardEmpty,
  GratitudeBoardInfo
};
